export default [
    {path: 'add'},      
    {path: 'upload'},
    {path: 'edit/:item_id'} ,
    {path: 'details/:item_id'} ,
    {path: 'delete/:item_id'} ,
]